import React, { useState } from 'react'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage } from '@/utils/layer'
import Table, { ColumnsType } from 'antd/lib/table'
import { StockInGoodsList } from '../stock-join-table/stock-join-table'
import { Row, Column } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import Button from '@/components/button/button'
import { Switch } from 'antd'

interface StockJoinPreviewProps {
    onSubmit: (newOrder: boolean) => void
    loading: boolean
    stockInList: StockInGoodsList[]
    stockOutList: StockInGoodsList[]
}

const StockJoinPreview: React.FC<StockJoinPreviewProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('stock-join-form', ...arg)

    const [isNewOrder, setIsNewOrder] = useState<boolean>(true)

    const columns: (h: boolean) => ColumnsType<StockInGoodsList> = (h: boolean) => [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '商品名',
            key: 'goods',
            ellipsis: true,
            dataIndex: 'goods',
            render: val => val.name,
        },
        {
            title: '采购量',
            align: 'right',
            dataIndex: 'stocking_in_amount',
        },
        {
            title: h ? '待入库量' : '入库量',
            align: 'right',
            dataIndex: 'stocked_in_amount',
        },
    ]

    return (
        <BaseDialog
            isShow
            title="确认入库单"
            onClose={() => {
                layerManage.pop()
            }}
            styles={{
                minWidth: '120px',
            }}
        >
            <Row data-padding-16>
                <Column className={cls('preview')}>
                    <div className={cls('preview', 'title')}>入库清单({props.stockInList.length})</div>
                    <Table
                        rowKey={record => record.id}
                        dataSource={props.stockInList}
                        columns={columns(false)}
                        bordered
                        pagination={false}
                        scroll={{ y: '300px' }}
                    />
                </Column>
                {!!props.stockOutList.length && (
                    <Column data-margin-left-16 className={cls('preview')}>
                        <div className={cls('preview', 'title')}>
                            未到货清单({props.stockInList.length})
                            <div data-color-999 data-font-size-14>
                                将生成新的入库单
                            </div>
                        </div>
                        <Table dataSource={props.stockOutList} columns={columns(true)} bordered pagination={false} />
                    </Column>
                )}
            </Row>
            <Row data-margin-top-10 data-justify-content-space-between data-margin-bottom-16 data-margin-h-16>
                <Row data-align-items-center>
                    <Switch
                        defaultChecked
                        onChange={e => {
                            setIsNewOrder(e)
                        }}
                    />
                    <div data-color-333 data-font-weight-600 data-font-size-14 data-margin-left-10>
                        将未到货商品生成新的待入库单
                    </div>
                </Row>
                <Button types="default" loading={props.loading} onClick={() => props.onSubmit(isNewOrder)}>
                    确定
                </Button>
            </Row>
        </BaseDialog>
    )
}

export default StockJoinPreview
